import React, {Component} from 'react';

import WidgetButton from './components/WidgetButton/WidgetButton';
import ChatContainer from './components/ChatContainer/ChatContainer';

class App extends Component {

  state= {
    chatIsOpen: false
  }

  toggleChatHandler = () =>{
    if (this.props.isMobile) return;
    this.setState(prevState => (
      {chatIsOpen: !prevState.chatIsOpen}
    ))
  }

  render(){

    return (
      
        <div className="ChatBot" lang={this.props.lng}>
          {/* <a href="#cbWidgetButton">Jump to the part of the page with the “anchor-name” id </a> */}
          <WidgetButton 
            show={!this.props.isMobile && !this.state.chatIsOpen}
            click={this.toggleChatHandler} />
          <ChatContainer 
            lng = {this.props.lng}
            show= {this.props.isMobile || this.state.chatIsOpen}
            isMobile = {this.props.isMobile}
            closeChat = {this.toggleChatHandler} />  
        </div>
      );
    }
  }


export default App;
